import DITokens from '@/domain/download/DITokens'
import { ApplicationDownload } from '@/domain/download/model/ApplicationDownload'
import type { IDownloadRepository } from '@/domain/download/repository/contract/IDownloadRepository'
import { inject, injectable } from 'inversify'

@injectable()
export class GetAvailableApplicationsDownloadLinkUseCase {
  constructor(
    @inject(DITokens.repository.IApplicationDownloadRepository)
    private readonly applicationDownloadRepository: IDownloadRepository,
  ) {
  }

  public async execute(): Promise<ApplicationDownload[]> {
    return await this.applicationDownloadRepository.getAvailableApplications()
  }
}
